import React from "react";
import {
  Box,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  VStack,
} from "@chakra-ui/react";

export interface BuyTimeControlProps {
  buyTimeValue: string;
  isBuyTimeSelected: boolean;
  isExpired: boolean;
  onToggle: () => void;
  onValueChange: (value: string) => void;
}

export const BuyTimeControl: React.FC<BuyTimeControlProps> = ({
  buyTimeValue,
  isBuyTimeSelected,
  isExpired,
  onToggle,
  onValueChange,
}) => (
  <VStack spacing={0.5} align="center">
    <Box
      as="button"
      px={3}
      py={1}
      h="32px"
      borderRadius="full"
      border="1px solid"
      borderColor={isBuyTimeSelected ? "blue.500" : "gray.400"}
      bg={isBuyTimeSelected ? "blue.100" : "white"}
      cursor={isExpired ? "not-allowed" : "pointer"}
      opacity={isExpired ? 0.5 : 1}
      display="flex"
      alignItems="center"
      gap={2}
      transition="all 0.2s ease"
      _hover={
        isExpired
          ? {}
          : {
              borderColor: isBuyTimeSelected ? "blue.600" : "blue.300",
              bg: isBuyTimeSelected ? "blue.100" : "blue.50",
            }
      }
      _active={
        isExpired
          ? {}
          : {
              borderColor: "blue.600",
              bg: "blue.100",
            }
      }
      onClick={onToggle}
    >
      <Text
        fontSize="0.8rem"
        fontWeight={isBuyTimeSelected ? "700" : "600"}
        color={isBuyTimeSelected ? "blue.700" : "gray.700"}
        fontFamily="'Nunito','Inter', sans-serif"
      >
        BUY TIME
      </Text>
      <InputGroup size="xs" w="55px" onClick={(e) => e.stopPropagation()}>
        <Input
          type="number"
          min={0.1}
          step={0.1}
          placeholder="-"
          textAlign="center"
          value={buyTimeValue}
          onChange={(e) => onValueChange(e.target.value)}
          isDisabled={isExpired}
          borderColor="gray.400"
          borderRadius="full"
          fontSize="0.75rem"
          fontWeight="600"
          bg="white"
          _focus={{
            borderColor: "blue.400",
            boxShadow: "0 0 0 1px var(--chakra-colors-blue-400)",
          }}
        />
        <InputRightElement width="32px" pointerEvents="none">
          <Text fontSize="0.65rem" color="gray.500" mr={1} fontWeight="800">
            hrs
          </Text>
        </InputRightElement>
      </InputGroup>
    </Box>
    <Box
      h="0"
      overflow="visible"
      display="flex"
      justifyContent="center"
      w="full"
    >
      <Text
        fontSize="0.6rem"
        fontWeight="600"
        color={isBuyTimeSelected ? "blue.500" : "gray.600"}
        fontFamily="'Nunito','Inter', sans-serif"
        whiteSpace="nowrap"
        mt="-2px"
      >
        Offline Discovery
      </Text>
    </Box>
  </VStack>
);
